import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from '@progress/kendo-react-inputs';
import React, { Component } from 'react'
import { SimpleConfigContext } from '../../../Context/Portal/SimpleConfigContext'
import Skeleton from '../../Shared/Skeleton/Skeleton';
import { withTranslation } from 'react-i18next';

class General extends Component {

    static contextType = SimpleConfigContext;

    state = {
        ORIENTATIONS: [
            { text: "Top", value: "Top" },
            { text: "Left", value: "Left" }
        ]
    }

    componentDidMount() {
        if (this.props.tReady) {
            this.setState({
                ORIENTATIONS: [
                    { text: this.props.t('orientations.top'), value: "Top" },
                    { text: this.props.t('orientations.left'), value: "Left" }
                ]
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tReady !== prevProps.tReady && this.props.tReady === true) {
            this.setState({
                ORIENTATIONS: [
                    { text: this.props.t('orientations.top'), value: "Top" },
                    { text: this.props.t('orientations.left'), value: "Left" }
                ]
            });
        }
    }

    getOrientation = (dataItem) => {
        const orientation = dataItem.value || dataItem;
        return this.state.ORIENTATIONS.find(x => x.value === orientation);
    }

    render() {

        const {
            loading,
            navigationBarOrientation,
            setNavigationBarOrientation,
            enableDashboard,
            setEnableDashboard,
            enableReporting,
            setEnableReporting,
            isWorkflowEnabled,
            setIsWorkflowEnabled,
            enableHistoryReporting,
            setEnableHistoryReporting,
            enableCommentReporting,
            setEnableCommentReporting,
            portal
        } = this.context;

        if (loading) {
            return (
                <div className='container-fluid'>
                    <Skeleton
                        rows={[
                            { full: true },
                            { full: true },
                        ]} />
                </div>
            )
        }

        return (
            <div className="m-10">
                {/* Only show navigation bar orientation for non-mobile portals */}
                {!portal.isMobilePortal && (
                    <div className="mb-3">
                        <h6 className="text-small">
                            {this.props.t("form_labels.navigation_bar_orientation")}
                        </h6>
                        <DropDownList
                            data={this.state.ORIENTATIONS}
                            className="customDropDown w-25"
                            value={this.getOrientation(navigationBarOrientation)}
                            onChange={setNavigationBarOrientation}
                            textField='text'
                            dataItemKey='value'
                        />
                    </div>
                )}
                <div>
                    <Checkbox
                        label={this.props.t("form_labels.enable_dashboard")}
                        checked={enableDashboard}
                        onChange={setEnableDashboard}
                        disabled={portal.isMobilePortal}
                    />
                </div>
                <div>
                    <Checkbox
                        label={this.props.t("form_labels.enable_reporting")}
                        checked={enableReporting}
                        onChange={setEnableReporting}
                        disabled={portal.isMobilePortal}
                    />
                </div>
                <div>
                    <Checkbox
                        label={this.props.t("form_labels.enable_workflow")}
                        checked={isWorkflowEnabled}
                        onChange={(e) => setIsWorkflowEnabled(e.target.value)}
                        disabled={portal.isMobilePortal}
                    />
                </div>
                <div>
                    <Checkbox
                        label={this.props.t("form_labels.enable_history_reporting")}
                        checked={enableHistoryReporting}
                        onChange={setEnableHistoryReporting}
                        disabled={portal.isMobilePortal}
                    />
                </div>
                <div>
                    <Checkbox
                        label={this.props.t("form_labels.enable_comment_reporting")}
                        checked={enableCommentReporting}
                        onChange={setEnableCommentReporting}
                        disabled={portal.isMobilePortal}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation("portal_simple_config/general")(General);